import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";
import $api from "../../api/$api";
import {
  TCreateCanvasEntry,
  TCreateCanvasLayout,
  TDataToken,
  TQueries,
  TUpdateCanvasEntry,
  TUpdateCanvasLayout
} from "./type";

export const getCanvasData = (data: TDataToken, queries: TQueries) => {
  return $api
    .get(`/canvas-details`, { token: data.accessToken, params: { ...queries } })
    .then((response) => {
      return response;
    });
};

export const useGetCanvasData = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["canvas", queries],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getCanvasData(data, queries),
    ...(config as UseQueryOptions<any>)
  });
};

// get canvas layout
export const getCanvasLayout = (data: TDataToken) => {
  return $api
    .get(`/canvas_layouts`, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useGetCanvasLayout = (data: TDataToken, config?: {}) => {
  return useQuery({
    queryKey: ["canvas_layout"],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getCanvasLayout(data),
    ...(config as UseQueryOptions<any>)
  });
};

// create canvas layout
export const createCanvasLayout = (
  data: TDataToken,
  payload: TCreateCanvasLayout
) => {
  return $api
    .post("canvas_layouts", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateCanvasLayout = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateCanvasLayout>
) => {
  return useMutation({
    mutationFn: (payload: TCreateCanvasLayout) =>
      createCanvasLayout(data, payload),
    ...config
  });
};

// update canvas layout
export const updateCanvasLayout = (
  data: TDataToken,
  payload: TUpdateCanvasLayout
) => {
  return $api
    .put("canvas_layouts", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateCanvasLayout = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateCanvasLayout>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateCanvasLayout) =>
      updateCanvasLayout(data, payload),
    ...config
  });
};

// create canvas entry
export const createCanvasEntry = (
  data: TDataToken,
  payload: TCreateCanvasEntry
) => {
  return $api
    .post("refactor/entry", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateCanvasEntry = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateCanvasEntry>
) => {
  return useMutation({
    mutationFn: (payload: TCreateCanvasEntry) =>
      createCanvasEntry(data, payload),
    ...config
  });
};

// update canvas entry
export const updateCanvasEntry = (
  data: TDataToken,
  payload: TUpdateCanvasEntry
) => {
  return $api
    .put("refactor/entry", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateCanvasEntry = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateCanvasEntry>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateCanvasEntry) =>
      updateCanvasEntry(data, payload),
    ...config
  });
};
